

























































import { Component, Vue } from 'vue-property-decorator';
import SaveButton from '@/components/App/SaveButton.vue';
import axios from 'axios';
import env from '@/env';

@Component({
  components: { SaveButton }
})
export default class UserView extends Vue {
  newUser = {
    name: this.user.name || '',
    email: this.user.email || '',
    password: '',
    repeat_password: ''
  };

  private changePassword = false;

  private logout() {
    window.location.pathname = '/api/logout';
  }

  private passwordsValid() {
    return (
      (this.newUser.password && this.newUser.password === this.newUser.repeat_password) ||
      'Passwörter stimmen nicht überein'
    );
  }

  get dataValid() {
    return (
      this.newUser.name.length &&
      this.newUser.email.length &&
      (!this.changePassword || this.passwordsValid() === true)
    );
  }

  get user() {
    return this.$store.state.user;
  }

  private changeLanguage(value: number) {
    const language = this.$store.state.languages.find((l: any) => l.id === value);
    console.log(language);
    this.$root.$i18n.locale = language.key;
  }

  async save() {
    const newUser = {
      ...this.user,
      ...this.newUser
    };
    if (!this.changePassword) {
      delete newUser.password;
      delete newUser.repeat_password;
    }

    await axios.post(`${env.backend_url}/user/update`, newUser);
    return true;
  }
}
